export const VIEWMODES = {
	carousel: 'carousel',
	grid: 'grid',
};
